import LazyImage from "components/lazy-image";
import { ComponentPropsWithoutRef } from "react";
import styles from "./styles.module.scss";

type Props = ComponentPropsWithoutRef<typeof LazyImage>;
const PatientAvatar = (props: Props) => (
  <LazyImage
    className={styles["patient-avatar"]}
    roundedCircle
    width={40}
    height={40}
    {...props}
  />
);
export default PatientAvatar;
